import { cross } from "d3";

// FILTER GENERATORS
export const setFromArrayValues = (data, ...f) => {
  const values = [...data.flatMap((d) => f.flatMap((k) => k(d)))];
  const sortedValues = [...values].sort();
  return new Set(sortedValues);
};

// Test whether the provided value exists inside the array of provided columns
export const filterExistenceInColumns = (row, value, columns) => {
  return columns.reduce((acc, column) => acc || row[column] === value, false);
};

export const setFromKeys = (data, ...f) => {
  const s = new Set();

  data.forEach((d) => {
    const key = f.reduce(
      (acc, func, idx) => `${acc}${idx !== 0 ? `-` : ``}${func(d)}`,
      ``
    );
    !s.has(key) && s.add(key);
  });
  return s;
};

/**
 * Flatten a row that has multiple values in a field.
 * This will turn
 
 [
    {
      associations: ["TOGO", "SPAIN"],
      target: ["A", "B"],
    },
  ] 

  into
 
  [
    { associations: ["TOGO"], target: ["A"] },
    { associations: ["TOGO"], target: ["B"] },
    { associations: ["SPAIN"], target: ["A"] },
    { associations: ["SPAIN"], target: ["B"] },
  ]
 * @param {[Object]} data
 * @param  {[function, string]} f the accessor func and the provided key to export the flattened column
 */
export const flattenOneToMany = (data, ...f) => {
  return data.flatMap((d) => {
    // array of null is needed for the cartesian product op to work
    const combinations = cross(
      ...f.map(([func]) => (func(d).length ? func(d) : [null]))
    );

    return combinations.flatMap((...vals) => {
      const o = { ...d };
      f.forEach(([, acc], i) => (o[acc] = !!vals[0][i] ? [vals[0][i]] : []));
      return o;
    });
  });
};

// TODO This is used for the buffer animations — it might be a bottleneck
export const indexOfAll = (arr, val) =>
  arr.reduce((acc, el, i) => (el === val ? [...acc, i] : acc), []);

export const groupBy = (data, key) => {
  const out = Object.values(
    data.reduce(
      (acc, curr) => ({
        ...acc,
        [curr[key]]: {
          name: curr[key],
          children: acc[curr[key]]
            ? acc[curr[key]].children.concat(curr)
            : [curr],
        },
      }),
      {}
    )
  ).filter((d) => d.name);
  return out;
};

export const uniqueByKey = (data, keyFunc) => {
  return [...new Map(data.map((x) => [keyFunc(x), x])).values()];
};
